import type { Dict } from "../core.js";
import type { auth as vi } from "../vi/auth.js";

export const auth: Dict<typeof vi> = {
  serverUnreachable: "Couldn't reach the server. Please try again.",
  devServerUnreachable: "Couldn't reach the dev server. Is `pnpm bube-hq:dev` running?",
  email: "Email",
  password: "Password",

  "login.subtitle": "Internal control center. Staff only.",
  "login.submit": "Sign in",
  "login.submitting": "Signing in…",
  "login.dev": "Dev sign-in (owner account) — local only",

  "change.title": "Change temporary password",
  "change.intro": "Your temporary password was shown in a terminal, so it is short-lived.",
  "change.expiresAt": "Expires at {at}.",
  "change.current": "Current password",
  "change.new": "New password",
  "change.minLength": "At least 12 characters.",
  "change.confirm": "Confirm new password",
  "change.mismatch": "Passwords don't match.",
  "change.mismatchSubmit": "The new passwords don't match.",
  "change.submit": "Change password",
  "change.submitting": "Saving…",
};
